// import React, { useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { FleetrifyCustomTable, Column } from "../CustomTable/customTable";
// import { ColumnConfig } from "../../utils/exportUtils";
// import { Service } from "../../redux/services/serviceApi";
// import { format } from "date-fns";

// export interface ServiceData {
//   id: string;
//   service: string;
//   category: string;
//   price: string;
//   priceModel: string;
//   vehicles: string;
//   status: string;
//   date: string;
//   rawData: Service;
// }

// interface ServicesTableProps {
//   services: Service[];
//   isLoading: boolean;
//   search?: string;
//   onExportData?: (data: { rows: ServiceData[]; columns: ColumnConfig[] }) => void;
//   currentPage?: number;
//   lastPage?: number;
//   totalItems?: number;
//   pageSize?: number;
//   onPageChange?: (page: number) => void;
// }

// const ServicesTable: React.FC<ServicesTableProps> = ({
//   services,
//   isLoading,
//   search = "",
//   onExportData,
//   currentPage = 1,
//   lastPage = 1,
//   totalItems = 0,
//   pageSize = 10,
//   onPageChange,
// }) => {
//   const navigate = useNavigate();
  
//   const formatDate = (dateString: string) => {
//     try {
//       return format(new Date(dateString), "MMMM dd, yyyy");
//     } catch {
//       return dateString || "N/A";
//     }
//   };

//   const formatPrice = (price: string) => {
//     try {
//       const numericPrice = parseFloat(price);
//       if (isNaN(numericPrice)) return "0.00";
//       return numericPrice.toLocaleString("en-NG", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       });
//     } catch {
//       return "0.00";
//     }
//   };

//   const formatPriceModel = (priceModel: string) => {
//     if (!priceModel) return "N/A";
//     return priceModel
//       .replace(/_/g, " ")
//       .split(" ")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(" ");
//   };

//   const formatStatus = (service: Service) => {
//     const status = service.status?.toLowerCase() || "active";
//     return status === "active" ? "Active" : "Inactive";
//   };

//   const tableData: ServiceData[] = useMemo(() => {
//     return services.map((service, index) => {
//       const globalIndex = (currentPage - 1) * pageSize + index + 1;
//       return {
//         id: `#${globalIndex}`,
//         service: service.service_type_name || "N/A",
//         category: service.service_type_name || "N/A",
//         price: formatPrice(service.base_price === "0.00" ? service.price : service.base_price),
//         priceModel: formatPriceModel(service.price_model),
//         vehicles: service.vehicle_type || "N/A",
//         status: formatStatus(service),
//         date: formatDate(service.created_at),
//         rawData: service,
//       };
//     });
//   }, [services, currentPage, pageSize]);

//   const columns: Column[] = useMemo(() => [
//     {
//       label: "ID",
//       key: "id",
//       sortable: false,
//     },
//     {
//       label: "Service",
//       key: "service",
//       sortable: false,
//     },
//     {
//       label: "Category",
//       key: "category",
//       sortable: false,
//     },
//     {
//       label: "Price",
//       key: "price",
//       sortable: true,
//       render: (value) => (
//         <span className="font-medium text-[#00032A]">₦{value}</span>
//       ),
//     },
//     {
//       label: "Price model",
//       key: "priceModel",
//       sortable: false,
//     },
//     {
//       label: "Vehicles type",
//       key: "vehicles",
//       sortable: false,
//       render: (value) => (
//         <span className=" text-[#606060]">{value}</span>
//       ),
//     },
//     {
//       label: "Status",
//       key: "status",
//       sortable: false,
//       render: (value) => (
//         <span
//           className={`inline-flex px-3 py-1 font-medium rounded-full ${
//             value === "Active"
//               ? "bg-green-100 text-green-700"
//               : value === "Inactive"
//               ? "bg-red-100 text-red-700"
//               : "bg-gray-100 text-gray-700"
//           }`}
//         >
//           {value}
//         </span>
//       ),
//     },
//     {
//       label: "Date created",
//       key: "date",
//       sortable: false,
//     },
//   ], []);

//   const exportColumns: ColumnConfig[] = useMemo(
//     () =>
//       columns.map((col) => ({
//         key: String(col.key),
//         label: col.label,
//       })),
//     [columns]
//   );

//   const filteredTableData = useMemo(() => {
//     if (!search.trim()) return tableData;

//     const searchLower = search.toLowerCase();
//     return tableData.filter(
//       (row) =>
//         row.id.toLowerCase().includes(searchLower) ||
//         row.service.toLowerCase().includes(searchLower) ||
//         row.category.toLowerCase().includes(searchLower) ||
//         row.priceModel.toLowerCase().includes(searchLower) ||
//         row.vehicles.toLowerCase().includes(searchLower) ||
//         row.status.toLowerCase().includes(searchLower)
//     );
//   }, [tableData, search]);

//   useEffect(() => {
//     if (onExportData) {
//       onExportData({ rows: filteredTableData, columns: exportColumns });
//     }
//   }, [filteredTableData, exportColumns, onExportData]);

//   if (isLoading && services.length === 0) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="flex flex-col items-center gap-3">
//           <div className="h-10 w-10 border-4 border-gray-300 border-t-[#143887] rounded-full animate-spin" />
//           <p className="text-sm text-gray-500">Loading services...</p>
//         </div>
//       </div>
//     );
//   }

//   if (services.length === 0 && !isLoading) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="text-center">
//           <div className="text-5xl text-gray-300 mb-4">📦</div>
//           <p className="text-gray-600 font-medium text-base mb-1">No services found</p>
//           <p className="text-gray-400 text-sm">
//             Create your first service to get started.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (filteredTableData.length === 0 && search) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="text-center">
//           <div className="text-5xl text-gray-300 mb-4">🔍</div>
//           <p className="text-gray-600 font-medium text-base mb-1">
//             No services match your search
//           </p>
//           <p className="text-gray-400 text-sm">
//             Try adjusting your search terms
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <FleetrifyCustomTable
//       data={filteredTableData}
//       columns={columns}
//       checkbox={false}
//       onRowClick={(row) => navigate(`/services/view-service/${row.rawData.id}`)}
//       isLoading={isLoading}
//       tableHeadClassName="bg-[#F8F9FA] text-[#00032A] border-r border-gray-200 last:border-r-0"
//       tableBodyClassName="text-[#606060] border-r border-gray-200 last:border-r-0"
//       tableTitle="All Services"
//       hideFooter={false}
//       tableClassName="border-separate border-spacing-0"
//       currentPage={currentPage}
//       lastPage={lastPage}
//       totalPage={totalItems}
//       pageSize={pageSize}
//       setCurrentPage={onPageChange}
//     />
//   );
// };

// export default ServicesTable;


// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FleetrifyCustomTable, Column } from "../CustomTable/customTable";
// import { ColumnConfig } from "../../utils/exportUtils";
// import { Service, ServiceRoute } from "../../redux/services/serviceApi";
// import { format } from "date-fns";
// import { ChevronDown, ChevronUp } from "lucide-react";

// export interface ServiceData {
//   id: string;
//   service: string;
//   category: string;
//   price: string;
//   priceModel: string;
//   vehicles: string;
//   status: string;
//   date: string;
//   rawData: Service;
// }

// interface ServicesTableProps {
//   services: Service[];
//   isLoading: boolean;
//   search?: string;
//   onExportData?: (data: { rows: ServiceData[]; columns: ColumnConfig[] }) => void;
//   currentPage?: number;
//   lastPage?: number;
//   totalItems?: number;
//   pageSize?: number;
//   onPageChange?: (page: number) => void;
// }

// const RoutesCell: React.FC<{ routes: ServiceRoute[] }> = ({ routes }) => {
//   const [expanded, setExpanded] = useState(false);

//   const formatRoutePrice = (price: string | number) => {
//     const num = parseFloat(String(price));
//     if (isNaN(num)) return "0.00";
//     return num.toLocaleString("en-NG", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//   };

//   return (
//     <div className="flex flex-col gap-1" style={{ minWidth: 180, whiteSpace: "normal" }}>
//       <button
//         type="button"
//         onClick={(e) => {
//           e.stopPropagation();
//           setExpanded((p) => !p);
//         }}
//         className="inline-flex items-center gap-1.5 text-xs font-medium text-[#143887] hover:text-[#0f2a66] transition-colors w-fit"
//       >
//         <span className="bg-[#e4ebf8] border border-[#c5d5ef] text-[#143887] rounded-full px-2 py-0.5 text-xs font-semibold">
//           {routes.length} {routes.length === 1 ? "route" : "routes"}
//         </span>
//         {expanded ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
//       </button>

//       {expanded && (
//         <div className="flex flex-col gap-2 mt-1 pl-2 border-l-2 border-[#e4ebf8]">
//           {routes.map((route, i) => (
//             <div key={route.id ?? i} className="flex flex-col gap-0.5">
//               <span className="text-xs text-[#00032A] font-medium" style={{ whiteSpace: "normal" }}>
//                 {route.from}
//                 <span className="text-gray-400 mx-1">→</span>
//                 {route.to}
//               </span>
//               <span className="text-xs text-[#143887] font-semibold">
//                 ₦{formatRoutePrice(route.price)}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

//

// const ServicesTable: React.FC<ServicesTableProps> = ({
//   services,
//   isLoading,
//   search = "",
//   onExportData,
//   currentPage = 1,
//   lastPage = 1,
//   totalItems = 0,
//   pageSize = 10,
//   onPageChange,
// }) => {
//   const navigate = useNavigate();

//   const formatDate = (dateString: string) => {
//     try {
//       return format(new Date(dateString), "MMMM dd, yyyy");
//     } catch {
//       return dateString || "N/A";
//     }
//   };

//   const formatPrice = (price: string) => {
//     try {
//       const numericPrice = parseFloat(price);
//       if (isNaN(numericPrice)) return "0.00";
//       return numericPrice.toLocaleString("en-NG", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       });
//     } catch {
//       return "0.00";
//     }
//   };

//   const formatPriceModel = (priceModel: string) => {
//     if (!priceModel) return "N/A";
//     return priceModel
//       .replace(/_/g, " ")
//       .split(" ")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(" ");
//   };

//   const formatStatus = (service: Service) => {
//     const status = service.status?.toLowerCase() || "active";
//     return status === "active" ? "Active" : "Inactive";
//   };

//   const getPriceForExport = (service: Service): string => {
//     if (service.routes && service.routes.length > 0) {
//       return service.routes
//         .map((r) => `${r.from} → ${r.to}: ₦${formatPrice(String(r.price))}`)
//         .join(" | ");
//     }
//     const p =
//       service.base_price && service.base_price !== "0.00"
//         ? service.base_price
//         : service.price;
//     return formatPrice(p);
//   };

//   const tableData: ServiceData[] = useMemo(() => {
//     return services.map((service, index) => {
//       const globalIndex = (currentPage - 1) * pageSize + index + 1;
//       return {
//         id: `#${globalIndex}`,
//         service: service.service_type_name || "N/A",
//         category: service.service_type_name || "N/A",
//         price: getPriceForExport(service),
//         priceModel: formatPriceModel(service.price_model),
//         vehicles: service.vehicle_type || "N/A",
//         status: formatStatus(service),
//         date: formatDate(service.created_at),
//         rawData: service,
//       };
//     });
//   }, [services, currentPage, pageSize]);

//   const columns: Column[] = useMemo(() => [
//     {
//       label: "ID",
//       key: "id",
//       sortable: false,
//     },
//     {
//       label: "Service",
//       key: "service",
//       sortable: false,
//     },
//     {
//       label: "Category",
//       key: "category",
//       sortable: false,
//     },
//     {
//       label: "Price",
//       key: "price",
//       sortable: true,
//       render: (_value: any, row: ServiceData) => {
//         const service: Service = row.rawData;

//         if (service.routes && service.routes.length > 0) {
//           return <RoutesCell routes={service.routes} />;
//         }

//         const displayPrice =
//           service.base_price && service.base_price !== "0.00"
//             ? service.base_price
//             : service.price;

//         return (
//           <span className="font-medium text-[#00032A]">
//             ₦{formatPrice(displayPrice)}
//           </span>
//         );
//       },
//     },
//     {
//       label: "Price model",
//       key: "priceModel",
//       sortable: false,
//     },
//     {
//       label: "Vehicles type",
//       key: "vehicles",
//       sortable: false,
//       render: (value: any) => (
//         <span className="text-[#606060]">{value}</span>
//       ),
//     },
//     {
//       label: "Status",
//       key: "status",
//       sortable: false,
//       render: (value: any) => (
//         <span
//           className={`inline-flex px-3 py-1 font-medium rounded-full ${
//             value === "Active"
//               ? "bg-green-100 text-green-700"
//               : value === "Inactive"
//               ? "bg-red-100 text-red-700"
//               : "bg-gray-100 text-gray-700"
//           }`}
//         >
//           {value}
//         </span>
//       ),
//     },
//     {
//       label: "Date created",
//       key: "date",
//       sortable: false,
//     },
//   ], []);

//   const exportColumns: ColumnConfig[] = useMemo(
//     () => columns.map((col) => ({ key: String(col.key), label: col.label })),
//     [columns]
//   );

//   const filteredTableData = useMemo(() => {
//     if (!search.trim()) return tableData;
//     const searchLower = search.toLowerCase();
//     return tableData.filter(
//       (row) =>
//         row.id.toLowerCase().includes(searchLower) ||
//         row.service.toLowerCase().includes(searchLower) ||
//         row.category.toLowerCase().includes(searchLower) ||
//         row.priceModel.toLowerCase().includes(searchLower) ||
//         row.vehicles.toLowerCase().includes(searchLower) ||
//         row.status.toLowerCase().includes(searchLower)
//     );
//   }, [tableData, search]);

//   useEffect(() => {
//     if (onExportData) {
//       onExportData({ rows: filteredTableData, columns: exportColumns });
//     }
//   }, [filteredTableData, exportColumns, onExportData]);

//   if (isLoading && services.length === 0) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="flex flex-col items-center gap-3">
//           <div className="h-10 w-10 border-4 border-gray-300 border-t-[#143887] rounded-full animate-spin" />
//           <p className="text-sm text-gray-500">Loading services...</p>
//         </div>
//       </div>
//     );
//   }

//   if (services.length === 0 && !isLoading) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="text-center">
//           <div className="text-5xl text-gray-300 mb-4">📦</div>
//           <p className="text-gray-600 font-medium text-base mb-1">No services found</p>
//           <p className="text-gray-400 text-sm">Create your first service to get started.</p>
//         </div>
//       </div>
//     );
//   }

//   if (filteredTableData.length === 0 && search) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="text-center">
//           <div className="text-5xl text-gray-300 mb-4">🔍</div>
//           <p className="text-gray-600 font-medium text-base mb-1">No services match your search</p>
//           <p className="text-gray-400 text-sm">Try adjusting your search terms</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <FleetrifyCustomTable
//       data={filteredTableData}
//       columns={columns}
//       checkbox={false}
//       onRowClick={(row) => navigate(`/services/view-service/${row.rawData.id}`)}
//       isLoading={isLoading}
//       tableHeadClassName="bg-[#F8F9FA] text-[#00032A] border-r border-gray-200 last:border-r-0"
//       tableBodyClassName="text-[#606060] border-r border-gray-200 last:border-r-0 !whitespace-normal"
//       tableTitle="All Services"
//       hideFooter={false}
//       tableClassName="border-separate border-spacing-0"
//       currentPage={currentPage}
//       lastPage={lastPage}
//       totalPage={totalItems}
//       pageSize={pageSize}
//       setCurrentPage={onPageChange}
//     />
//   );
// };

// export default ServicesTable;


import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FleetrifyCustomTable, Column } from "../CustomTable/customTable";
import { ColumnConfig } from "../../utils/exportUtils";
import { Service, ServiceRoute } from "../../redux/services/serviceApi";
import { format } from "date-fns";
import { ChevronDown, ArrowRight, Truck, Route as RouteIcon } from "lucide-react";
import { FleetrifyModal } from "../Modal/modal";

export interface ServiceData {
  id: string;
  service: string;
  category: string;
  price: string;
  routes: ServiceRoute[];
  priceModel: string;
  vehicles: string;
  status: string;
  date: string;
  rawData: Service;
}

interface ServicesTableProps {
  services: Service[];
  isLoading: boolean;
  search?: string;
  onExportData?: (data: { rows: ServiceData[]; columns: ColumnConfig[] }) => void;
  currentPage?: number;
  lastPage?: number;
  totalItems?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
}

const RoutesCell: React.FC<{ routes: ServiceRoute[]; serviceName?: string }> = ({
  routes,
  serviceName,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formatRoutePrice = (price: string | number) => {
    const num = parseFloat(String(price));
    if (isNaN(num)) return "0.00";
    return num.toLocaleString("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  if (!routes || routes.length === 0) {
    return <span className="text-gray-400 text-xs">—</span>;
  }

  return (
    // Stops clicks anywhere in this cell — including the portaled modal's
    // own close button — from bubbling to the table row's onRowClick. React
    // portals still bubble through the component tree, not the DOM tree.
    <div onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="group inline-flex items-center gap-1.5 rounded-full border border-[#c5d5ef] bg-[#e4ebf8] pl-2.5 pr-2 py-1 text-xs font-semibold text-[#143887] shadow-sm transition-all duration-200 hover:bg-[#143887] hover:border-[#143887] hover:text-white hover:shadow-md active:scale-95 w-fit"
      >
        <RouteIcon size={13} className="flex-shrink-0" />
        <span>{routes.length} {routes.length === 1 ? "route" : "routes"}</span>
        <ChevronDown
          size={13}
          className="flex-shrink-0 transition-transform duration-200 group-hover:translate-y-0.5"
        />
      </button>

      <FleetrifyModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={serviceName ? `Routes — ${serviceName}` : "Routes"}
        className="w-[90%] sm:w-[480px] max-w-full h-auto max-h-[80vh]"
      >
        <div
          className="flex flex-col gap-2 p-4 sm:p-6 overflow-y-auto"
          style={{ maxHeight: "60vh" }}
        >
          {routes.map((route, i) => (
            <div
              key={route.id ?? i}
              className="flex items-center gap-3 rounded-md border border-gray-100 bg-white px-3 py-2.5 shadow-sm"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 text-sm font-medium text-[#00032A]">
                  <span className="truncate">{route.from}</span>
                  <ArrowRight size={13} className="text-gray-300 flex-shrink-0" />
                  <span className="truncate">{route.to}</span>
                </div>
                {route.vehicle_type && (
                  <span className="inline-flex items-center gap-1 mt-1 text-xs text-gray-500">
                    <Truck size={11} className="flex-shrink-0" />
                    {route.vehicle_type}
                  </span>
                )}
              </div>
              <span className="flex-shrink-0 text-sm font-semibold text-[#143887] bg-[#e4ebf8] rounded-full px-2.5 py-1">
                ₦{formatRoutePrice(route.price)}
              </span>
            </div>
          ))}
        </div>
      </FleetrifyModal>
    </div>
  );
};

const ServicesTable: React.FC<ServicesTableProps> = ({
  services,
  isLoading,
  search = "",
  onExportData,
  currentPage = 1,
  lastPage = 1,
  totalItems = 0,
  pageSize = 10,
  onPageChange,
}) => {
  const navigate = useNavigate();

  const hasAnyRoutes = useMemo(
    () => services.some((s) => s.routes && s.routes.length > 0),
    [services]
  );

  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), "MMMM dd, yyyy");
    } catch {
      return dateString || "N/A";
    }
  };

  const formatPrice = (price: string) => {
    try {
      const numericPrice = parseFloat(price);
      if (isNaN(numericPrice)) return "0.00";
      return numericPrice.toLocaleString("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch {
      return "0.00";
    }
  };

  const formatPriceModel = (priceModel: string) => {
    if (!priceModel) return "N/A";
    return priceModel
      .replace(/_/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const formatStatus = (service: Service) => {
    const status = service.status?.toLowerCase() || "active";
    return status === "active" ? "Active" : "Inactive";
  };

  const getPriceDisplay = (service: Service): string => {
    if (service.routes && service.routes.length > 0) return "—";
    const p =
      service.base_price && service.base_price !== "0.00"
        ? service.base_price
        : service.price;
    return formatPrice(p);
  };

  const getPriceForExport = (service: Service): string => {
    if (service.routes && service.routes.length > 0) {
      return service.routes
        .map((r) => `${r.from} → ${r.to}: ₦${formatPrice(String(r.price))}`)
        .join(" | ");
    }
    const p =
      service.base_price && service.base_price !== "0.00"
        ? service.base_price
        : service.price;
    return formatPrice(p);
  };

  const tableData: ServiceData[] = useMemo(() => {
    return services.map((service, index) => {
      const globalIndex = (currentPage - 1) * pageSize + index + 1;
      return {
        id: `#${globalIndex}`,
        service: service.service_type_name || "N/A",
        category: service.service_type_name || "N/A",
        price: getPriceDisplay(service),
        routes: service.routes ?? [],
        priceModel: formatPriceModel(service.price_model),
        vehicles: service.vehicle_type || "N/A",
        status: formatStatus(service),
        date: formatDate(service.created_at),
        rawData: service,
      };
    });
  }, [services, currentPage, pageSize]);

  const baseColumns: Column[] = useMemo(() => [
    {
      label: "ID",
      key: "id",
      sortable: false,
    },
    {
      label: "Service",
      key: "service",
      sortable: false,
    },
    {
      label: "Category",
      key: "category",
      sortable: false,
    },
    {
      label: "Price",
      key: "price",
      sortable: true,
      render: (value: any, row: ServiceData) => {
        if (row.routes && row.routes.length > 0) {
          return <span className="text-gray-400 text-xs">—</span>;
        }
        return (
          <span className="font-medium text-[#00032A]">
            ₦{value}
          </span>
        );
      },
    },
  ], []);

  const routesColumn: Column = useMemo(() => ({
    label: "Routes",
    key: "routes",
    sortable: false,
    render: (_value: any, row: ServiceData) => (
      <RoutesCell routes={row.routes} serviceName={row.service} />
    ),
  }), []);

  const tailColumns: Column[] = useMemo(() => [
    {
      label: "Price model",
      key: "priceModel",
      sortable: false,
    },
    {
      label: "Vehicles type",
      key: "vehicles",
      sortable: false,
      render: (value: any) => (
        <span className="text-[#606060]">{value}</span>
      ),
    },
    {
      label: "Status",
      key: "status",
      sortable: false,
      render: (value: any) => (
        <span
          className={`inline-flex px-3 py-1 font-medium rounded-full ${
            value === "Active"
              ? "bg-green-100 text-green-700"
              : value === "Inactive"
              ? "bg-red-100 text-red-700"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          {value}
        </span>
      ),
    },
    {
      label: "Date created",
      key: "date",
      sortable: false,
    },
  ], []);

  const columns: Column[] = useMemo(() => {
    if (hasAnyRoutes) {
      return [...baseColumns, routesColumn, ...tailColumns];
    }
    return [...baseColumns, ...tailColumns];
  }, [hasAnyRoutes, baseColumns, routesColumn, tailColumns]);

  const exportColumns: ColumnConfig[] = useMemo(
    () => columns
      .filter((col) => col.key !== "routes") // routes column has its own export format via price
      .map((col) => ({ key: String(col.key), label: col.label })),
    [columns]
  );

  const filteredTableData = useMemo(() => {
    if (!search.trim()) return tableData;
    const searchLower = search.toLowerCase();
    return tableData.filter(
      (row) =>
        row.id.toLowerCase().includes(searchLower) ||
        row.service.toLowerCase().includes(searchLower) ||
        row.category.toLowerCase().includes(searchLower) ||
        row.priceModel.toLowerCase().includes(searchLower) ||
        row.vehicles.toLowerCase().includes(searchLower) ||
        row.status.toLowerCase().includes(searchLower)
    );
  }, [tableData, search]);

  useEffect(() => {
    if (onExportData) {
      onExportData({ rows: filteredTableData, columns: exportColumns });
    }
  }, [filteredTableData, exportColumns, onExportData]);

  if (isLoading && services.length === 0) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 border-4 border-gray-300 border-t-[#143887] rounded-full animate-spin" />
          <p className="text-sm text-gray-500">Loading services...</p>
        </div>
      </div>
    );
  }

  if (services.length === 0 && !isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="text-center">
          <div className="text-5xl text-gray-300 mb-4">📦</div>
          <p className="text-gray-600 font-medium text-base mb-1">No services found</p>
          <p className="text-gray-400 text-sm">Create your first service to get started.</p>
        </div>
      </div>
    );
  }

  if (filteredTableData.length === 0 && search) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="text-center">
          <div className="text-5xl text-gray-300 mb-4">🔍</div>
          <p className="text-gray-600 font-medium text-base mb-1">No services match your search</p>
          <p className="text-gray-400 text-sm">Try adjusting your search terms</p>
        </div>
      </div>
    );
  }

  return (
    <FleetrifyCustomTable
      data={filteredTableData}
      columns={columns}
      checkbox={false}
      onRowClick={(row) => navigate(`/services/view-service/${row.rawData.id}`)}
      isLoading={isLoading}
      tableHeadClassName="bg-[#F8F9FA] text-[#00032A] border-r border-gray-200 last:border-r-0"
      tableBodyClassName="text-[#606060] border-r border-gray-200 last:border-r-0 !whitespace-normal"
      tableTitle="All Services"
      hideFooter={false}
      tableClassName="border-separate border-spacing-0"
      currentPage={currentPage}
      lastPage={lastPage}
      total={totalItems}
      pageSize={pageSize}
      setCurrentPage={onPageChange}
    />
  );
};

export default ServicesTable;